import { TagDataFragment } from 'src/api/tags/_fragments/_tag_data_fragment'

export const OrganizationTagDataFragment = `
    id
    tag {
        ${TagDataFragment}
    } 
`
